import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { ReqCard } from './styles';
import { LaptopIcon, WifiIcon, CameraIcon, ShieldIcon } from './icons';

const ITEMS = [
    { icon: <LaptopIcon />, title: 'Laptop / desktop', desc: 'No phones or tablets.' },
    { icon: <WifiIcon />,   title: 'Stable internet',  desc: 'Wired or strong Wi-Fi.' },
    { icon: <CameraIcon />, title: 'Working webcam',   desc: 'Built-in or external.' },
    { icon: <ShieldIcon />, title: 'Admin rights',     desc: 'To install once.' },
];

export default function RequirementsGrid() {
    return (
        <Box component="section" sx={{ mb: 3 }}>
            <Grid container spacing={2}>
                {ITEMS.map((item) => (
                    <Grid item xs={6} sm={3} key={item.title}>
                        <ReqCard>
                            <Box sx={{ color: '#374151' }}>{item.icon}</Box>
                            <Typography fontWeight={600} fontSize="0.85rem" color="#111827">
                                {item.title}
                            </Typography>
                            <Typography variant="caption" color="text.secondary" lineHeight={1.4}>
                                {item.desc}
                            </Typography>
                        </ReqCard>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}
